const fetchApi = () => {
  const url = process.env.REACT_APP_API_URL
  console.log(url)
}

module.exports = {
  fetchApi,
}
